import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col justify-between px-8 pb-3 pt-6 h-[163px] transition-all duration-[350ms]',
  variants: {
    state: {
      default: 'bg-primary',
      focused: 'bg-primary shadow-lg',
      disabled: '',
    },
  },
  defaultVariants: {
    state: 'default',
  },
});

type ScoreColorRange = 'error' | 'warning' | 'high' | 'success';

function getScoreColorRange(score: number): ScoreColorRange {
  if (score < 40) return 'error';
  if (score < 60) return 'warning';
  if (score < 80) return 'high';
  return 'success';
}

const scoreColorMap: Record<ScoreColorRange, { default: string; disabled: string }> = {
  error: { default: 'text-error-primary', disabled: 'text-error-200' },
  warning: { default: 'text-fg-warning-secondary', disabled: 'text-warning-200' },
  high: { default: 'text-fg-green-yellow', disabled: 'text-green-yellow-200' },
  success: { default: 'text-fg-success-secondary', disabled: 'text-success-200' },
};

function getScoreColor(colorRange: ScoreColorRange, isDisabled: boolean): string {
  return scoreColorMap[colorRange][isDisabled ? 'disabled' : 'default'];
}

export { containerClasses, getScoreColor, getScoreColorRange };
export type { ScoreColorRange };
